import { Text } from '@lili/lili-frontend-common';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { LimitsListHeader } from './LimitsListHeader';
import { LimitsListRow } from './LimitListRow';
import { TierResponse } from '../AccountLimitsType';
import { ReactComponent as Icon } from '../../../assets/icons/svg/shared/ic-shared-password.svg';

interface LimitsModalRightComponentProps {
  teirData: TierResponse;
}
export const LimitsModalRightComponent = ({ teirData }: LimitsModalRightComponentProps) => {
  const { t } = useTranslation('limitsEN');

  return (
    <div>
      <div className='w-[628px] h-full px-[56px] py-[36px] flex flex-col  bg-surface-purple-secondary rounded-r-[12px]'>
        <div className='mb-4'>
          <Text.H10>{t('RIGHT_COMPONENT_HEADER')}</Text.H10>
        </div>
        <div className='bg-surface-primary-bw-00 w-[516px] h-[336px] rounded-lg border border-bw03'>
          <LimitsListHeader />

          {teirData.tiersDiff.map((tier) => (
            <LimitsListRow cell1={tier.localizedName} cell2={tier.limits} cell3={tier.limits} />
          ))}
        </div>
        <div className='mt-4 flex items-center'>
          <div className=' w-[16px] h-[16px] mr-1'>
            <Icon className=' w-[16px] h-[16px]' />
          </div>
          <Text.H10>{t('RIGHT_COMPONENT_TEXT1')}</Text.H10>
        </div>
      </div>
    </div>
  );
};
